module.exports = __webpack_public_path__ + "img/top_slider_supplementplus2.6bd24a9b.jpg";